import { Component, Input, AfterViewInit, EventEmitter, Output, ViewChild, OnDestroy, OnInit, NgZone } from '@angular/core';
import { Subscription } from 'rxjs';
import { Country } from 'src/@omnial/_models/order/country.model';
import { ScriptLoaderService } from 'src/@omnial/_services/external/script-load.service';
import { CheckoutService } from 'src/@omnial/_services/order/checkout.service';

@Component({
    selector: 'app-autocomplete',
    templateUrl: './../../../app/shared/autocomplete/autocomplete.component.html',
    standalone: false
})
export class AutoCompleteComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() addressType: string;
  @Input() addressTypeSecondary: string;
  @Input() allowedCountries: Country[];
  @Input() prompt = "Let Google find your Address";
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @ViewChild('addressText') addressText: any;
  public subscriptions: Subscription[] = [];

  autocompleteInput: string;
  queryWait: boolean;
  listenerAdded: boolean = false;

  constructor(public scriptLoaderService: ScriptLoaderService, public checkoutService: CheckoutService, public zone: NgZone) { }

  ngOnInit(): void {
    window['angularGoogleMapsReference'] = { component: this, zone: this.zone, googleMapsLoaded: () => this.googleMapsLoaded() };
  }

  googleMapsLoaded() {
    // Google Maps requires a callback method
  }

  ngAfterViewInit() {
    this.subscriptions.push(this.scriptLoaderService.scripts.subscribe(
      res => {
        const googleScript = res?.find(s => s.ref === 'Google Maps');
        if (googleScript?.loaded) {
          if (!this.listenerAdded) {
            this.listenerAdded = true;
            this.getPlaceAutocomplete();
          }
        }
        else if (!googleScript?.loading) {
          this.scriptLoaderService.load('Google Maps');
        }
      }));
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => { sub.unsubscribe(); });
    }
  }

  private getPlaceAutocomplete() {
    let countries: string[] = [];
    if (this.allowedCountries && this.allowedCountries.length > 0) {
      this.allowedCountries.forEach((allowed) => {
        countries.push(allowed.twoLetterIsoCode.toUpperCase());
      });
    } else {
      countries.push('AU'); // Shouldn't happen
    }
    let addressTypes = [this.addressType];
    if (this.addressTypeSecondary) {
      addressTypes.push(this.addressTypeSecondary);
    }
    const autocomplete = new google.maps.places.Autocomplete(this.addressText.nativeElement,
      {
        componentRestrictions: { country: countries },
        types: addressTypes  // 'establishment' / 'address' / 'geocode' / '(regions)'
      });
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      this.invokeEvent(place);
      this.addressText.nativeElement.value = '';
    });
  }

  invokeEvent(place: Object) {
    this.setAddress.emit(place);
  }
}
